import { Button, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import EmptyState from './empty-state';
import ListItemElement from './list-items-element';
import SectionItemTitle from './container-items';

const useStyles = makeStyles((theme: any) => ({
  // i18n value is lowercase ("password recovery"); capitalize keeps the shipped Title Case.
  recoveryButton: {
    textTransform: 'capitalize',
    '@media (hover: none) and (pointer: coarse)': { minHeight: theme.spacing(5.5) },
  },
}));

type AccessSectionProps = {
  contactId: string;
  username: string | null;
  onOpenAccessModal: () => void;
  onOpenRecoveryModal: () => void;
  deleteUser: (...args: any[]) => void;
  dispatchDelete: (action: any) => void;
};

const AccessSection: FC<AccessSectionProps> = ({
  contactId,
  username,
  onOpenAccessModal,
  onOpenRecoveryModal,
  deleteUser,
  dispatchDelete,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid item>
      <SectionItemTitle
        title={t('contact:accessTitle')}
        onClickIcon={username !== null ? undefined : onOpenAccessModal}
        additionalButton={
          username ? (
            <Button
              color="secondary"
              variant="outlined"
              className={classes.recoveryButton}
              onClick={onOpenRecoveryModal}
            >
              {t('contact:passwordRecoveryButton')}
            </Button>
          ) : undefined
        }
      >
        {username !== null ? (
          <ListItemElement
            title={t('contact:emailLabel')}
            value={username}
            disabledButton={false}
            onclickIcon={() => {
              dispatchDelete({
                type: 'delete',
                data: {
                  func: deleteUser,
                  params: { id: contactId },
                },
                message: t('contact:deleteAccessMessage'),
                title: t('contact:deleteAccessTitle'),
              });
            }}
          />
        ) : (
          <EmptyState />
        )}
      </SectionItemTitle>
    </Grid>
  );
};

export default AccessSection;
